<section class="aca-mig__card">
  <div class="aca-mig__empty" *ngIf="!loading && !rows().length">
    <mat-icon>check_circle_outline</mat-icon>
    <div class="aca-mig__emptytitle">{{ 'DMS.MIGRATION.EMPTY_ERRORS_TITLE' | translate }}</div>
    <div>{{ 'DMS.MIGRATION.EMPTY_ERRORS_DESC' | translate }}</div>
  </div>

  <div class="aca-mig__tablewrap" *ngIf="rows().length">
    <table class="aca-mig__table">
      <thead>
        <tr>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_ITEM' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_SOURCE_PATH' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_ERR_CODE' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_ERR_MSG' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_ATTEMPTS' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_LAST_ATTEMPT' | translate }}</th>
          <th class="aca-mig__th" style="text-align: right">{{ 'DMS.MIGRATION.COL_ACTION' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let r of paged(); trackBy: trackByRow">
          <td class="aca-mig__td aca-mig__mono">{{ r.item }}</td>
          <td class="aca-mig__td aca-mig__mono">{{ r.sourcePath || '—' }}</td>
          <td class="aca-mig__td">{{ r.code || '—' }}</td>
          <td class="aca-mig__td aca-mig__td--wrap">{{ r.message }}</td>
          <td class="aca-mig__td">{{ r.attempts ?? '—' }}</td>
          <td class="aca-mig__td">{{ dateLabel(r.lastAttempt) }}</td>
          <td class="aca-mig__td" style="text-align: right">
            <button
              type="button"
              class="aca-mig__btn aca-mig__btn--sm"
              [disabled]="busyKey() === r.item || api.available() !== true"
              [matTooltip]="api.available() === true ? '' : ('DMS.MIGRATION.NEEDS_BACKEND' | translate)"
              (click)="retry(r)"
            >
              {{ 'DMS.MIGRATION.RETRY' | translate }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="aca-mig__toolbar" *ngIf="pageCount() > 1">
      <button type="button" class="aca-mig__btn aca-mig__btn--sm" [disabled]="page() === 0" (click)="setPage(-1)">
        {{ 'DMS.MIGRATION.PAGE_PREV' | translate }}
      </button>
      <span>{{ 'DMS.MIGRATION.PAGE_RANGE' | translate: pageRange() }}</span>
      <button type="button" class="aca-mig__btn aca-mig__btn--sm" [disabled]="page() >= pageCount() - 1" (click)="setPage(1)">
        {{ 'DMS.MIGRATION.PAGE_NEXT' | translate }}
      </button>
    </div>
  </div>
</section>
